import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api, { getToken, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    // null = checking, false = anonymous, object = signed-in
    const [user, setUser] = useState(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (!getToken()) {
                if (!cancelled) setUser(false);
                return;
            }
            try {
                const { data } = await api.get("/auth/me");
                if (!cancelled) setUser(data);
            } catch {
                if (!cancelled) setUser(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    const login = useCallback(async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setToken(data.access_token);
        setUser(data.user);
        return data.user;
    }, []);

    const signup = useCallback(async (email, password) => {
        const { data } = await api.post("/auth/signup", { email, password });
        return data;
    }, []);

    const logout = useCallback(() => {
        setToken(null);
        setUser(false);
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser, login, signup, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
};
